module.exports = __webpack_public_path__ + "dist/images/a0d2ec7cf5e59aa615f72a3737f5d346.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/select-role/school-leader.svg
// module id = 474
// module chunks = 0